// extracted by mini-css-extract-plugin
export default {"srText":"BEz5q2"};